import ConfigRepository from '@/shared/config/repository/configRepository'
import { epgEndpoint } from '@/api/apiConstants'
import {
    MAX_PROGRAMS_PER_CHANNEL_FETCH_AMOUNT,
    MAX_CHANNELS_PER_EPG_FETCH_CHUNK,
} from '@/shared/constants'
import { postWithAuth } from '@/api/httpRequests'
import { RawEpgObject, EpgChannelsRequestList } from '@/types/epg/Epg'

const configRepository = ConfigRepository.Instance

export const getPrograms = async (channelsId: string[]) => {
    const config = configRepository.getLocalConfig()
    if (!config) return null

    const defaultProgramsCount = MAX_PROGRAMS_PER_CHANNEL_FETCH_AMOUNT
    const defaultStartEpochSecs = Math.ceil(Date.now() / 1000) // Date.now() / 1000 i zaokrąglić

    const chunkArray = (
        channels: EpgChannelsRequestList[],
        chunkSize: number
    ) => {
        const chunks = []
        for (let i = 0; i < channels.length; i += chunkSize) {
            chunks.push(channels.slice(i, i + chunkSize))
        }

        return chunks
    }

    const epgChannelsRequestList = channelsId.map((id) => ({
        channelId: id,
        start: defaultStartEpochSecs,
        count: defaultProgramsCount,
    }))

    epgChannelsRequestList.sort(
        (channelA, channelB) =>
            Number(channelA.channelId) - Number(channelB.channelId)
    )

    const chunkedRequests: EpgChannelsRequestList[][] = chunkArray(
        epgChannelsRequestList,
        MAX_CHANNELS_PER_EPG_FETCH_CHUNK
    )

    let allResponses: RawEpgObject[] = []
    for (const chunk of chunkedRequests) {
        const stringifiedChannels = JSON.stringify(chunk)
        const programsResponse = await postWithAuth(
            epgEndpoint,
            true,
            stringifiedChannels
        )

        allResponses = allResponses.concat(programsResponse)
    }

    return allResponses
}
